import apinode from '../../apinode'

class EstruturasService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getItemsByProductSku(productSku) {
    const response = await apinode.get(
      `/estruturas/${this.idconta}/${productSku}`,
    )

    return response.data
  }

  async getAllProductsBySKUComposition(sku) {
    const response = await apinode.get(
      `/estruturas/products/${sku}/${this.idconta}`,
    )

    return response.data
  }

  async create(items) {
    await apinode.post(`/estruturas/${this.idconta}`, {
      KIT_COMPOSICAO: items,
    })
  }

  async adjust(skuToRemove, kitsSku, skuToAdd) {
    await apinode.put(`/estruturas/${this.idconta}`, {
      skuToRemove,
      kitsSku,
      skuToAdd,
    })
  }

  async delete(id) {
    await apinode.delete(`/estruturas/${this.idconta}/${id}`)
  }
}

export default new EstruturasService()
